import axios from 'axios'
import { useState, useContext, useEffect } from 'react'
import { UserContext } from '../../context api/UserContext'
import urlSearchParams from '../../components/urlSearchParams'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, getNewToken } from '../../shared/constants'

export const useIncentive = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [incentives, setIncentives] = useState([])
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState({})
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })
  const [positions, setPositions] = useState([])
  const [cancelToken, setCancelToken] = useState()
  const [managers, setManagers] = useState({})
  const downloadKeys = {
    INCENTIVES: 'INCENTIVES',
    ACHIEVEMENT_REPORT: 'ACHIEVEMENT_REPORT',
    INCENTIVE_REPORT: 'INCENTIVE_REPORT',
    QUATERLY_EARNING_REPORT: 'QUATERLY_EARNING_REPORT',
    QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT: 'QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT',
  }

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])

  const downloadAPI = (key, val) => {
    switch (key) {
      case downloadKeys.INCENTIVES:
        return API.GET_ALL_INCENTIVES(urlSearchParams(val))
      case downloadKeys.ACHIEVEMENT_REPORT:
        return API.GET_ACHIEVEMENT_REPORT_ONLY(urlSearchParams(val))
      case downloadKeys.INCENTIVE_REPORT:
        return API.GET_INCENTIVE_REPORT(urlSearchParams(val))
      case downloadKeys.QUATERLY_EARNING_REPORT:
        return API.GET_QUATERLY_EARNING_REPORT(urlSearchParams(val))
      case downloadKeys.QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT:
        return API.GET_QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT(urlSearchParams(val))
      default:
        return ''
    }
  }

  const getAllIncentive = async (dto = {}) => {
    axios
      .get(API.GET_ALL_INCENTIVES(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        setIncentives(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getAchievementReport = async (dto = {}) => {
    axios
      .get(API.GET_ACHIEVEMENT_REPORT_ONLY(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        setIncentives(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getPdfCsvData = async (key = '', dto = {}) => {
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    axios
      .get(downloadAPI(key, dto), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
        setPositions(data.positions)
        setManagers(data.allManagerNames)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getQuaterlyVsActualAchievementReport = async (dto = {}) => {
    axios
      .get(API.GET_QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setPaginate(data.paginate)
        setIncentives(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getQuaterlyEarningReport = async (dto = {}) => {
    axios
      .get(API.GET_QUATERLY_EARNING_REPORT(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setPaginate(data.paginate)
        setIncentives(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getIncentiveReport = async (dto = {}) => {
    axios
      .get(API.GET_INCENTIVE_REPORT(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setPaginate(data.paginate)
        setIncentives(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    getAllIncentive,
    getAchievementReport,
    getPdfCsvData,
    getIncentiveReport,
    getQuaterlyEarningReport,
    getQuaterlyVsActualAchievementReport,
    managers,
    incentives,
    loading,
    paginate,
    downloadLoading,
    pdfCsvData,
    downloadKeys,
    positions,
  }
}
